const types = {
    LIVESTREAM_ABORT_HARDWARE_SETTINGS: 'LIVESTREAM_ABORT_HARDWARE_SETTINGS',
    LIVESTREAM_AUDIO_STARTED: 'LIVESTREAM_AUDIO_STARTED',
    LIVESTREAM_CONFIRM_HARDWARE_SETTINGS: 'LIVESTREAM_CONFIRM_HARDWARE_SETTINGS',
    LIVESTREAM_HARDWARE_ACCESS_CLOSED: 'LIVESTREAM_HARDWARE_ACCESS_CLOSED',
    LIVESTREAM_HARDWARE_ACCESS_GRANTED: 'LIVESTREAM_HARDWARE_ACCESS_GRANTED',
    LIVESTREAM_HARDWARE_ACCESS_REJECTED: 'LIVESTREAM_HARDWARE_ACCESS_REJECTED',
    LIVESTREAM_REMOVE_OFFERER: 'LIVESTREAM_REMOVE_OFFERER',
    LIVESTREAM_SET_LIVESESSION: 'LIVESTREAM_SET_SESSION',
    LIVESTREAM_SET_MIC_HEALTH_CHECK_STATUS: 'LIVESTREAM_SET_MIC_HEALTH_CHECK_STATUS',
    LIVESTREAM_SET_OFFERER_CONNECTION_STATUS: 'LIVESTREAM_SET_OFFERER_CONNECTION_STATUS',
    LIVESTREAM_SET_OFFERER: 'LIVESTREAM_SET_OFFERER',
    LIVESTREAM_SET_PROCTORING_MODE: 'LIVESTREAM_SET_PROCTORING_MODE',
    LIVESTREAM_SET_ROOM_SCAN_CONFIRMATION: 'LIVESTREAM_TOGGLE_ROOM_SCAN_CONFIRMATION',
    LIVESTREAM_SET_WEBCAM_HEALTH_CHECK_STATUS: 'LIVESTREAM_SET_WEBCAM_HEALTH_CHECK_STATUS',
    LIVESTREAM_SETUP_FAILED: 'LIVESTREAM_SETUP_FAILED',
    LIVESTREAM_SWITCH_DEVICES: 'LIVESTREAM_SWITCH_DEVICES',
    LIVESTREAM_SWITCH_SPEAKER_DEVICE: 'LIVESTREAM_SWITCH_SPEAKER_DEVICE',
    LIVESTREAM_WEBCAM_STARTED: 'LIVESTREAM_WEBCAM_STARTED',
};

const hardwareAccessStatus = {
    NOT_REQUESTED: 'NOT_REQUESTED',
    GRANTED: 'GRANTED',
    REJECTED: 'REJECTED',
    CLOSED: 'CLOSED',
};

const webcamHealthCheckStatus = {
    UNDIAGNOSED: 'UNDIAGNOSED',
    PASSED: 'PASSED',
    FAILED: 'FAILED',
};

const proctoringMode = {
    CALL: 'CALL',
    WATCH: 'WATCH',
};

const sessionProblem = {
    SETUP_FAILED: 'SETUP_FAILED',
};

// Mirrors LiveSessionPushMessageBuilderImpl.MessageType.
const liveSessionMessageType = {
    ARE_YOU_ONLINE_CANDIDATE: 'ARE_YOU_ONLINE_CANDIDATE',
    ICE_CANDIDATES: 'ICE_CANDIDATES',
    LEFT_SESSION: 'LEFT_SESSION',
    OFFER: 'OFFER',
    PROCTORING_MODE_UPDATED: 'PROCTORING_MODE_UPDATED',
    TT_EVICTION_REQUESTED: 'TT_EVICTION_REQUESTED',
};

const liveSessionConnectionStatus = {
    CONNECTED: 'CONNECTED',
    RECONNECTING: 'RECONNECTING',
};

const livestreamActions = {
    types,
    hardwareAccessStatus,
    liveSessionConnectionStatus,
    liveSessionMessageType,
    proctoringMode,
    sessionProblem,
    webcamHealthCheckStatus,

    grantHardwareAccess(devices) {
        return { type: types.LIVESTREAM_HARDWARE_ACCESS_GRANTED, devices };
    },

    rejectHardwareAccess() {
        return { type: types.LIVESTREAM_HARDWARE_ACCESS_REJECTED };
    },

    closeHardwareAccess() {
        return { type: types.LIVESTREAM_HARDWARE_ACCESS_CLOSED };
    },

    setWebcamLivestreamAsStarted() {
        return { type: types.LIVESTREAM_WEBCAM_STARTED };
    },

    setAudioLivestreamAsStarted() {
        return { type: types.LIVESTREAM_AUDIO_STARTED };
    },

    confirmHardwareSettings() {
        return { type: types.LIVESTREAM_CONFIRM_HARDWARE_SETTINGS };
    },

    abortHardwareSettings() {
        return { type: types.LIVESTREAM_ABORT_HARDWARE_SETTINGS };
    },

    switchDevices(webcamDeviceId, audioDeviceId) {
        return { type: types.LIVESTREAM_SWITCH_DEVICES, webcamDeviceId, audioDeviceId };
    },

    switchSpeakerDevice(speakerDeviceId) {
        return {
            type: types.LIVESTREAM_SWITCH_SPEAKER_DEVICE,
            speakerDeviceId,
        };
    },

    setRoomScanConfirmation(isConfirmed) {
        return { type: types.LIVESTREAM_SET_ROOM_SCAN_CONFIRMATION, isConfirmed };
    },

    setLiveSession(liveSessionId) {
        return { type: types.LIVESTREAM_SET_LIVESESSION, liveSessionId };
    },

    setMicHealthCheckStatus(status) {
        return { type: types.LIVESTREAM_SET_MIC_HEALTH_CHECK_STATUS, status };
    },

    /**
     * Register the offerer proctor.
     * @param messagerId The AssessmentRunSessionContributorId
     * @param newProctoringMode Either Watch or Call.
     * @param proctoringModeSetTime The time at which the proctoringMode was updated.
     * @param liveSessionTimestamp The time at which this P2P session was made available to the proctor.
     * This is available to the proctor via API GetLiveSession. We use this token plus the messageId in order to determine
     * to which exact WebRTC connection we are referring to. This is because the same messagerId could refer to old/stale
     * connections made previously (f.e. while proctor was in Watch before navigating to Call).
     *
     * @returns {{type: string, messagerId: *, proctoringMode: *, proctoringModeSetTime: *, liveSessionTimestamp: *}}
     */
    setOfferer(messagerId, newProctoringMode, proctoringModeSetTime, liveSessionTimestamp) {
        return {
            type: types.LIVESTREAM_SET_OFFERER,
            messagerId,
            proctoringMode: newProctoringMode,
            proctoringModeSetTime,
            liveSessionTimestamp,
        };
    },

    setProctoringMode(messagerId, newProctoringMode, proctoringModeSetTime) {
        return { type: types.LIVESTREAM_SET_PROCTORING_MODE, messagerId, proctoringMode: newProctoringMode, proctoringModeSetTime };
    },

    removeOfferer(messagerId) {
        return { type: types.LIVESTREAM_REMOVE_OFFERER, messagerId };
    },

    deemSessionSetupFailed(messagerId) {
        return { type: types.LIVESTREAM_SETUP_FAILED, messagerId };
    },

    setConnectionStatus(messagerId, status, liveSessionTimestamp) {
        return {
            type: types.LIVESTREAM_SET_OFFERER_CONNECTION_STATUS,
            messagerId,
            connectionStatus: status,
            liveSessionTimestamp,
        };
    },

    setWebcamHealthCheckStatus(status) {
        return {
            type: types.LIVESTREAM_SET_WEBCAM_HEALTH_CHECK_STATUS,
            status,
        };
    },
};

export default livestreamActions;
